export default __webpack_public_path__ + "static/media/1540.c5f38676.png";